import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Login from "./screens/Login";
import ResetPwd from "./screens/ResetPwd";
import ForgotPwd from "./screens/ForgotPwd";
import Integration from "./screens/Integration";
import NewPresentation from "./screens/NewPresentation";
import ConfirmationPage from "./screens/ForgotPwd/components/ConfirmationPage";
import TokenExpired from "./screens/ResetPwd/components/TokenExpired";
import PwdAlreadyReset from "./screens/ResetPwd/components/PwdAlreadyReset";
import PwdResetFailed from "./screens/ResetPwd/components/PwdResetFailed";
import Go from './screens/Login/components/Go'
import RouteWithCanonical from "./RouteWithCanonical"

const Routes = () => {
  return (
    <Switch>
      <RouteWithCanonical path="/login/" exact component={Login} />
      <RouteWithCanonical path="/login/resetpwd" component={ResetPwd} />
      <RouteWithCanonical path="/login/forgotpwd" component={ForgotPwd} />
      <RouteWithCanonical path="/login/integration" component={Integration} />
      <RouteWithCanonical path="/login/new-presentation" component={NewPresentation} />
      {/* Temp routes for testing/review convenience */}
      <RouteWithCanonical path="/login/confirm" component={ConfirmationPage} />
      <RouteWithCanonical path="/login/expired" component={TokenExpired} />
      <RouteWithCanonical path="/login/already" component={PwdAlreadyReset} />
      <RouteWithCanonical path="/login/failed" component={PwdResetFailed} />
      <RouteWithCanonical path="/login/go" component={Go} />
      <Route path="*" render={() => <Redirect to="/login/" />} />
    </Switch>
  );
};

export default Routes;
